import { adTechLog } from '../../general/log';
import { updateAdSlot } from '../../general/ad-slot-storage';
import { googletagDisplay } from './display';

/**
 * The slots provided have previously been displayed and destroyed before.
 *
 * @param {Array} slots An array of formatted slots.
 */
export const googletagDisplayAgain = ( slots ) => {

	if ( ! slots.length ) {
		adTechLog( {
			type: 'info',
			message: `No selected slots to display again.`,
			details: {
				slots
			}
		} )
	}

	let slotsToDisplay = [];

	// Ensure that were only doing this for slots that have been destroyed.
	for ( const slot of slots ) {

		if ( slot.destroyed ) {

			// Update the ad slot as destroyed.
			slot.destroyed = false;
			slot.status_step_1_defined = false;
			slot.status_step_2_request = false;
			slot.status_step_3_received = false;
			slot.status_step_4_rendered = false;
			slot.status_step_5_loaded = false;
			slot.status_step_6_viewable = false;

			updateAdSlot( slot );

			window.adTech.googletag.slotDefineFunctions[ slot.id ].func();

			slotsToDisplay.push( slot );
		}
	}

	if ( slotsToDisplay.length !== slots.length ) {
		adTechLog( {
			type: 'warning',
			message: `Selected slots to display again. The number of slots does not match the previously destroyed slots.`,
			details: {
				slotsToDisplay,
				slots
			}
		} );
		window.googletag.cmd.push(function( ) {
			if ( slots.length ) {
				googletagDisplay( slots );
				window.googletag.pubads().refresh();
			}
		});
	} else {
		adTechLog( {
			type: 'info',
			message: `Selected slots to display again.`,
			details: {
				slotsToDisplay,
				slots
			}
		} );
		window.googletag.cmd.push(function( ) {
			if ( slotsToDisplay.length ) {
				googletagDisplay( slotsToDisplay );
				window.googletag.pubads().refresh();
			}
		});
	}
}